import * as constants from './views-types';

export default {
  [constants.SET_VIEW] (state, { view, type }) {
    state[type] = view;
  },
}
